module.exports = __webpack_public_path__ + "img/服务伙伴01.77dcc367.png";